import { SigninButton } from "common/SigninButton";
import { CTA } from "common/styleguide/CTA";
import { Msg, useFormatMessage } from "lib/localization";
import { buildQueryString } from "lib/utils";
import _ from "lodash";
import querystring from "querystring";
import React from "react";
import { defineMessages, FormattedMessage as T } from "react-intl";
import { s2dMessages } from "../intlMessages";
import { S2DLayout } from "../S2DLayout";
import styles from "./CreateAccountStep.scss";

const message = defineMessages({
  plsCreateAccount: {
    id: "s2d.plsCreateAccount",
    defaultMessage: "Please create an account to continue",
  },
});

export const CreateAccountStep = ({ selectedDevice, onPrev }) => {
  const { hot } = querystring.parse(window.location.search.substring(1));
  const postSignin = true;
  const query = hot
    ? buildQueryString({ hot, postSignin, selectedDevice })
    : buildQueryString({ postSignin, selectedDevice });
  let deviceString;
  if (selectedDevice === "iphone") {
    deviceString = "apple";
  } else {
    deviceString = selectedDevice;
  }
  deviceString = _.capitalize(deviceString);
  const redirect = `${window.location.pathname}?${query}`;
  const signupURL = `/signup?redirect=${encodeURIComponent(redirect)}`;
  const fm = useFormatMessage();

  return (
    <S2DLayout
      title={<Msg m={s2dMessages.createAccount} />}
      step={2}
      onClickPrev={onPrev}
      onClickNext={() => {}}
      disableNext={fm(message.plsCreateAccount)}
    >
      <div className={styles.CreateAccountStep}>
        <p>
          <T
            id="s2d.createAccount1"
            defaultMessage="To send the route to your {deviceString} device, you will need to create a free account with Ride with GPS."
            values={{ deviceString }}
          />
        </p>
        <CTA href={signupURL}>
          <Msg m={s2dMessages.createAccount} />
        </CTA>
        <p>
          <T id="s2d.createAccount2" defaultMessage="Already have an account?" />
        </p>
        <SigninButton redirectTo={redirect} />
      </div>
    </S2DLayout>
  );
};
